import React from "react";
import Popup from "reactjs-popup";

const DeleteConfirmationModal = ({
  open,
  onClose,
  onConfirm,
  title,
  message,
}) => {
  return (
    <Popup open={open} onClose={onClose} modal closeOnDocumentClick>
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">{title}</h5>
          <button
            type="button"
            className="btn-close"
            onClick={onClose}
            aria-label="Close"
          ></button>
        </div>
        <div className="modal-body">
          <p>{message}</p>
        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-secondary" onClick={onClose}>
            Cancel
          </button>
          <button type="button" className="btn btn-danger" onClick={onConfirm}>
            Delete
          </button>
        </div>
      </div>
    </Popup>
  );
};

export default DeleteConfirmationModal;
